<template>
  <div class="header-container">
    <md-card>
      <div class="content">
        <drop-down
          direction="down"
          @dropDownOpen="getNotifications"
        >
          <div class="notification-icon">
            <i
              class="fa fas fa-bell"
              data-toggle="dropdown"
            />
            <div
              v-if="notificationCount > 0"
              class="notification-alert"
            />
          </div>

          <ul class="dropdown-menu dropdown-menu-right">
            <span class="notification-title ">Notifications ({{ notificationCount }})</span>
            <div class="scrollable">
              <div v-if="todayNotifications.length">
                <span class="sub-title">Today</span>
                <li
                  v-for="notification in todayNotifications"
                  :key="notification._id"
                  :class="{'bold': !notification.read}"
                >
                  <a :href="notification.link">
                    <notifications-menu :notification="notification" />
                  </a>
                </li>
              </div>
              <div v-if="earlierNotifications.length">
                <span class="sub-title">Earlier</span>
                <li
                  v-for="notification in earlierNotifications"
                  :key="notification._id"
                  :class="{'bold': !notification.read}"
                >
                  <a :href="notification.link">
                    <notifications-menu :notification="notification" />
                  </a>
                </li>
              </div>
            </div>
            <div class="actions">
              <md-button
                class="md-info md-simple"
                @click="navigateToNotification"
              >
                Show all
              </md-button>
            </div>
          </ul>
        </drop-down>
      </div>
    </md-card>
  </div>
</template>

<script>
import NotificationsMenu from './notifications-menu';
export default {
  name: 'HeaderView',
  components: { NotificationsMenu },
  data() {
    return {
      todayNotifications: [],
      earlierNotifications: [],
      notificationCount: 0,
    }
  },
  mounted() {
    this.getNotificationCount();
  },
  methods: {
    getNotifications(isOpen) {
      if (isOpen) {
        this.$store
            .dispatch("queryAPI", { url: "/rest/notfication", options: { limit: 10 } })
            .then(res => {
              const isToday = (someDate) => {
                const today = new Date();
                const myDate = new Date(someDate)
                return myDate.getDate() == today.getDate() &&
                    myDate.getMonth() == today.getMonth() &&
                    myDate.getFullYear() == today.getFullYear();
              }
              for (let i = 0; i <= res.length; i++) {
                if (res[i] && res[i].createdAt) {
                  const created = res[i].createdAt;
                  if (isToday(created)) {
                    this.todayNotifications = [...this.todayNotifications, res[i]];
                  } else {
                    this.earlierNotifications = [...this.earlierNotifications, res[i]];
                  }
                }
              }
              this.markNotificationsAsRead()
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                icon: "add_alert",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "danger"
              });
            });
      } else {
        this.todayNotifications = [];
        this.earlierNotifications = [];
      }
    },
    getNotificationCount() {
      this.$store
          .dispatch("queryAPI", { url: "/rest/notfication/new" })
          .then(res => {
            this.notificationCount = res.count;
          })
          .catch(err => {
            this.$notify({
              timeout: 5000,
              message: err.message,
              icon: "add_alert",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          });
    },
    markNotificationsAsRead() {
      setTimeout(() => {
        this.$store
            .dispatch("queryAPI", { url: "/rest/notfication/read" })
            .then(() => {
              this.todayNotifications.map(n => n.read = true);
              this.earlierNotifications.map(n => n.read = true);
              this.getNotificationCount();
            })
            .catch(err => {
              this.$notify({
                timeout: 5000,
                message: err.message,
                icon: "add_alert",
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "danger"
              });
            });
      }, 3100)
    },
    navigateToNotification() {
      this.$router.push('/notifications')
    }
  }
}
</script>

<style lang="scss">
.header-container {
  height: 64px;
  width: 100%;
  position: relative;
  z-index: 3;
  .md-card {
    height: 100%;
    background: white;
    margin: 0 !important;
    border-radius: 0;
    display: flex;
    justify-content: center;
    .content {
      align-self: flex-end;
      margin-right: 20px;
      .dropdown {
        display: flex;
        .notification-title {
          font-size: 22px;
          font-weight: 500;
          padding-left: 26px;
          display: block;
          margin-bottom: 20px;
        }
        .sub-title {
          padding-left: 26px;
          font-weight: 500;
          font-size: 14px;
        }
        .bold {
          a {
            font-weight: 500;
          }
        }
        .actions {
          box-shadow: 0px -0.25px 1px rgb(104 86 86 / 4%), 0px -0.85px 3px rgb(74 60 60 / 19%);
          display: flex;
          justify-content: center;
          button {
            font-size: 14px;
          }
        }
      }
      .dropdown-menu {
        max-height: 400px;
        max-width: 400px;
        .scrollable {
          overflow-y: auto;
          max-height: 294px;
        }
      }
      .notification-icon {
        width: 46px;
        height: 46px;
        background: #FBE5E7;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          color: #DF263B;
          font-size: 21px;
        }

        .notification-alert {
          width: 10px;
          height: 10px;
          background: #005FB6;
          position: absolute;
          top: 11px;
          right: 11px;
          border-radius: 50%;
          border: 1px solid white;
        }
      }
    }
  }
}
</style>
